import {PiShieldPlusBold, LuFastForward, LuCode, LuCircleDollarSign, LuRuler, FiAirplay, FiHeart,TfiLayersAlt, BiBullseye,TbAward, PiNotebook, LuUser2, RxRulerSquare,FiWifi, LuUsers2,MdCropRotate,LuGlassWater, LuParkingCircle, LuWebhook, GrDatabase, TbFidgetSpinner,LuServerCog,TbCloudDownload, FiServer,PiBrowsersBold, LuTag, LuPencil, BiBriefcaseAlt2, FaRegChartBar, FiVolume2, LuUserCheck2, LuDollarSign, LuPizza, LiaBookReaderSolid, BiClinic, LuClover, LuEarOff } from '../assets/icons/vander'

import abuso_sustancias from '../assets/images/psicologo/abuso_sustancias.jpg'
import ansiedad from '../assets/images/psicologo/ansiedad.jpg'
import depresion from '../assets/images/psicologo/depresion.jpg'
import trastorno_bipolar from '../assets/images/psicologo/trastorno_bipolar.jpg'
import trastorno_panico from '../assets/images/psicologo/trastorno_panico.jpg'
import trastorno_sueño from '../assets/images/psicologo/trastorno_sueño.jpg'
import lily_imagen_nueva from '../assets/images/psicologo/trauma_post.jpg'
import toc from '../assets/images/psicologo/toc.jpg'
import tdah from '../assets/images/psicologo/tdah.jpg'


export const charityData = [
    {
        image:lily_imagen_nueva,
        title:'Trauma y trastorno de estrés postraumático',
        desc:'El trauma puede ocurrir tras sobrevivir o presenciar eventos que ponen en peligro la vida, como desastres naturales, accidentes o abuso. El trastorno de estrés postraumático (TEPT) puede desarrollarse si el cerebro no puede procesar adecuadamente un evento. Esto puede provocar flashbacks o pesadillas que pueden hacer que los pacientes alivien el trauma.',  
        enlace:'estrespostraumatico'    
    },
     {
        image:trastorno_bipolar,
        title:'Trastorno bipolar',
        desc:'Caracterizado por intensos cambios de humor y de energía, el trastorno bipolar puede afectar significativamente la capacidad de una persona para ir al trabajo o a la escuela, o para mantener relaciones saludables. Los episodios de ansiedad pueden ser maníacos (anormalmente felices) o depresivos y pueden durar semanas.',      
        enlace:'trastornobipolar'
    },
     {
        image:trastorno_panico,
        title:'Trastorno de pánico',
        desc:'Las personas que padecen este trastorno experimentan con frecuencia una oleada repentina de miedo intenso, incluso cuando no hay peligro evidente. No todas las personas que sufren un ataque de pánico desarrollan un trastorno de pánico.',      
        enlace:'trastornopanico'
    },
     {
        image:trastorno_sueño,
        title:'Trastorno del sueño',
        desc:'El insomnio, el síndrome de piernas inquietas, la narcolepsia y la apnea del sueño pueden ser signos de un problema de salud mental más grave. Si no se trata, el trastorno del sueño puede perturbar nuestra vida diaria y afectar gravemente la salud mental y física.',      
        enlace:'trastornosueno'
    },
     {
        image:abuso_sustancias,
        title:'Tratamiento del abuso de sustancias',
        desc:'Sustancias como el alcohol o las drogas pueden provocar adicciones graves que pueden arruinar vidas. Caracterizado por una concentración intensa en una sustancia específica, este trastorno puede causar pensamientos y comportamientos distorsionados y afectar a otras personas.',      
        enlace:'abusodesustancias'
    },
     {
        image:toc,
        title:'TOC',
        desc:'Aquellos pensamientos, impulsos o imágenes recurrentes y persistentes que se experimentan como intrusivos e inapropiados, y que causan una ansiedad o malestar considerables. El TOC puede ser muy debilitante, pero con el tratamiento adecuado, muchas personas pueden manejar sus síntomas y llevar una vida plena y funcional.',      
        enlace:'toc'
    },
     {
        image:depresion,
        title:'Depresión',
        desc:'Todos experimentamos depresión de vez en cuando. El trastorno depresivo mayor se define por una tristeza persistente, sentimientos de desesperanza o falta de interés en las actividades habituales. Si no se trata, la depresión puede afectar significativamente la capacidad para funcionar en el trabajo o con la familia.',      
        enlace:'depresion'
    },
     {
        image:ansiedad,
        title:'Ansiedad',
        desc:'Si bien los pensamientos ansiosos son una reacción natural al estrés, la ansiedad puede persistir incluso cuando no existe un peligro o amenaza real. A menudo acompañada de síntomas físicos, como taquicardia o dificultad para respirar, la ansiedad puede progresar a un ataque de pánico grave que puede hacer que las personas se sientan descontroladas.',      
        enlace:'ansiedad'
    },
     {
        image:tdah,
        title:'TDAH',
        desc:'El trastorno por déficit de atención e hiperactividad (TDAH) es una afección que suele comenzar en la infancia y puede persistir hasta la edad adulta. Sus síntomas incluyen un patrón persistente de hiperactividad, impulsividad y falta de atención, que puede perturbar la vida diaria y dificultar el funcionamiento normal.',      
        enlace:'tdah'
    }   
   
]
